export default function transform(tagSource, field) {
  if (tagSource === undefined
    || tagSource === null
    || !Array.isArray(tagSource)
    || tagSource.length === 0) {
    return null;
  }
  return tagSource.map(e => e[field]);
}
